import { render, staticRenderFns } from "./ProductBadgeYear.vue?vue&type=template&id=8be11104&"
import script from "./ProductBadgeYear.vue?vue&type=script&lang=js&"
export * from "./ProductBadgeYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports